import * as React from "react";
import PropTypes from "prop-types";
const SvgSportsMultiNormalSmall = React.forwardRef(
  ({ color = "currentColor", size = 24, title, titleId, ...props }, ref) => (
    <svg
      fill={color}
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      ref={ref}
      width={size}
      height={size}
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <g fill="">
        <path d="M13.5 10.556L11.434 14H10v2h2.566l.934-1.556 3 5L18.566 16H20v-2h-2.566l-.934 1.556z" />
        <path d="M16.686 4.314A9 9 0 104.315 16.685a9.046 9.046 0 003 3A9 9 0 1019.685 7.315a9.046 9.046 0 00-3-3zM9 2c1.335 0 2.583.374 3.645 1.023a9 9 0 00-9.622 9.622A7 7 0 019 2zM6 15c0 .217.008.432.023.645a7 7 0 019.622-9.622A9 9 0 006 15zm9-7a7 7 0 110 14 7 7 0 010-14z" />
      </g>
    </svg>
  )
);
SvgSportsMultiNormalSmall.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  title: PropTypes.string,
  titleId: PropTypes.string,
};
export default SvgSportsMultiNormalSmall;
